import type { ContractProposalDetailInvestment } from "Infrastructure/ApiZfp/Schema/contractProposalDetailInvestment";
import { type NsureSelection, NsureSelectionItemType, type StrategyInstrument } from "./InvestmentsNsureSelectionTypes";

type InstrumentLike = {
  instrumentID?: number;
  participationInPercentage?: number;
  instrument?: { name?: string | null } | null;
};

export const mapToStrategyInstruments = (items: InstrumentLike[]): StrategyInstrument[] =>
  items
    .map((item) => ({
      id: item.instrumentID,
      name: item.instrument?.name ?? null,
      participationInPercentage: item.participationInPercentage ?? 0,
    }))
    .filter((item): item is StrategyInstrument => item.id !== undefined);

export const buildInitialNsureSelection = (
  edit: boolean | undefined,
  investmentData: ContractProposalDetailInvestment | undefined,
): NsureSelection => {
  if (!edit || !investmentData?.portfolio) return null;
  const { portfolio } = investmentData;

  if (portfolio.strategyTemplateID != null) {
    return {
      type: NsureSelectionItemType.Portfolio,
      id: portfolio.strategyTemplateID,
      expectedPerformance: portfolio.expectedPerformance ?? null,
      name: portfolio.name,
      esg: portfolio.esg ?? null,
      srri: portfolio.srri ?? null,
      sri: portfolio.sri ?? null,
      instrumentType: null,
      strategyRiskType: null,
      strategyInstruments: mapToStrategyInstruments(portfolio.strategyInstruments),
      strategyInstrumentsEvaluation: mapToStrategyInstruments(portfolio.strategyInstruments),
    };
  }

  const first = portfolio.strategyInstruments[0];
  if (!first?.instrument) return null;
  return {
    type: NsureSelectionItemType.Instrument,
    id: first.instrumentID,
    expectedPerformance: portfolio.expectedPerformance ?? null,
    name: first.instrument.name,
    instrumentType: first.instrument.instrumentType,
    strategyInstruments: mapToStrategyInstruments(portfolio.strategyInstruments),
    strategyInstrumentsEvaluation: mapToStrategyInstruments(portfolio.strategyInstruments),
    isin: first.instrument.isin ?? null,
    ticker: first.instrument.ticker ?? null,
    minInvestmentHorizon: null,
    esg: portfolio.esg ?? null,
    srri: portfolio.srri ?? null,
    sri: portfolio.sri ?? null,
    instrumentRelations: null,
  };
};
